import React, { useState, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { IonContent, IonPage, IonButton, IonIcon, IonInput, IonItem, useIonToast, IonSelect, IonSelectOption } from "@ionic/react";
import Header from "src/components/Header";
import PanelFiscalizacion from "src/components/Fiscalizacion/PanelFiscalizacion";
import { fetchMaquinas, postMaquinas, IMaquina } from "../services/Fiscalizacion/Maquinas";
import { fetchCalificaciones, ICalificaciones } from "src/services/Fiscalizacion/Deposito";
import { search } from "ionicons/icons";
import "./Fiscalizacion.css";
import ComentarioFiscalizacion from "src/components/Fiscalizacion/ComentarioFiscalizacion";
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";

const MAQUINAS_POR_PAGINA = 5;

const FiscalizarMaquina: React.FC<RouteComponentProps> = ({ history }) => {
  const { setInformacionFiscalizacionMaquinas } = useFiscalizacion();
  const { pathname } = history.location;
  const params = pathname.split("/");

  // El fiscalizacion_id se encuentra en la posición 3 del array params
  const fiscalizacion_id = params[5];

  const [maquinas, setMaquinas] = useState<IMaquina[]>([]);
  const [filtro, setFiltro] = useState("");
  const [estados, setEstados] = useState<ICalificaciones[]>([]);
  const [estadosMaquinas, setEstadosMaquinas] = useState<{ [key: string]: number }>({});
  const [maquinasModificadas, setMaquinasModificadas] = useState<IMaquina[]>([]); // Array para almacenar las máquinas modificadas
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [present] = useIonToast();

  useEffect(() => {
    const cargarDatos = async () => {
      const { datos } = await fetchMaquinas(parseInt(fiscalizacion_id));
      if (datos) {
          const maquinas = datos.map((maquina: any) => ({
              id: maquina.id,
              codBien: maquina.codBien,
              descripcion: maquina.descripcion,
              condicion_id: maquina.condicion_id || null,
              descripcion_problema: maquina.descripcion_problema,
              fiscalizacion_id: maquina.fiscalizacion_id,
              dimensionObjeto: maquina.dimensionObjeto || "0",
              estado: maquina.estado || 0,
              origen: maquina.origen,
              calificacion: maquina.calificacion || null, // Mapea calificación correctamente
          }));
          setMaquinas(maquinas as IMaquina[]);
      }
  };
  
    cargarDatos();

    const calificaciones = async () => {
      const response = await fetchCalificaciones();
      if (!response.error) {
        const { datos } = response;
        const calificacionesFiltradas = datos.filter(calificacion => [5, 6, 7].includes(calificacion.id)).flat();
        setEstados(calificacionesFiltradas);
      } else {
        console.error('Error al obtener calificaciones:', response.error);
        // Manejar el error de alguna manera, por ejemplo, mostrando un mensaje al usuario
      }
    };
    
    calificaciones();
    
  }, [fiscalizacion_id]);

  const handleFiltroChange = (e: CustomEvent) => {
    setFiltro(e.detail.value);
  };

  const maquinasFiltradas = maquinas.filter(
    (maquina) =>
      (maquina.descripcion &&
        maquina.descripcion.toLowerCase().includes(filtro.toLowerCase())) ||
      maquina.codBien.toLowerCase().includes(filtro.toLowerCase())
  );

  const totalPaginas = Math.max(
    1,
    Math.ceil(maquinasFiltradas.length / MAQUINAS_POR_PAGINA)
  );

  const maquinasPaginadas = maquinasFiltradas.slice(
    (paginaActual - 1) * MAQUINAS_POR_PAGINA,
    paginaActual * MAQUINAS_POR_PAGINA
  );

  useEffect(() => {
    setPaginaActual(1);
  }, [filtro]);

  useEffect(() => {
    if (paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }
  }, [paginaActual, totalPaginas]);

  const handleEstadoChange = (maquinaCodigo: string, nuevoEstado: number) => {
    setEstadosMaquinas((prevEstados) => ({
      ...prevEstados,
      [maquinaCodigo]: nuevoEstado,
    }));

    // Verificar si la máquina ya ha sido modificada antes
    const maquinaModificadaIndex = maquinasModificadas.findIndex(maquina => maquina.codBien === maquinaCodigo);
    if (maquinaModificadaIndex === -1) {
      // Si la máquina no está en la lista de máquinas modificadas, agregarla
      const maquinaModificada = maquinas.find(maquina => maquina.codBien === maquinaCodigo);
      if (maquinaModificada) {
        setMaquinasModificadas(prevMaquinasModificadas => [...prevMaquinasModificadas, maquinaModificada]);
      }
    }
  };
  const handleCalificacionChange = (maquinaCodigo: string, nuevaCalificacion: number) => {
    setMaquinas((prevMaquinas) =>
        prevMaquinas.map((maquina) =>
            maquina.codBien === maquinaCodigo
                ? { ...maquina, calificacion: nuevaCalificacion } // Actualizamos solo calificación
                : maquina
        )
    );

    const maquinaModificada = maquinas.find(maquina => maquina.codBien === maquinaCodigo);
    if (maquinaModificada) {
        setMaquinasModificadas((prev) => {
            const yaModificada = prev.some((mod) => mod.codBien === maquinaCodigo);
            return yaModificada ? prev : [...prev, { ...maquinaModificada, calificacion: nuevaCalificacion }];
        });
    }
};


  const handleGuardar = async () => {
    setIsSubmitted(true);

    const maquinasParaGuardar = maquinasModificadas.map((maquina) => ({
      maquina_codigo: maquina.codBien,
      maquina_descripcion: maquina.descripcion,
      estado: maquina.estado,
      calificacion_id: maquina.calificacion,
      origen: maquina.origen
    }));

    setInformacionFiscalizacionMaquinas(maquinasParaGuardar)

    try {
      const response = await postMaquinas(maquinasParaGuardar, parseInt(fiscalizacion_id));
      if (response.exito) {
        present({
          color: "success",
          message: "Se guardaron los datos correctamente",
          duration: 3000,
        });
        history.goBack();
      } else {
        setIsSubmitted(false);
        present({
          color: "danger",
          message: response.info || "Ocurrió un error al guardar los datos",
          duration: 3000,
        });
      }      
    } catch (error) {
      present({
        color: "danger",
        message: "Error de conexión o del servidor",
        duration: 3000,
      });
    }
  };

  return (
    <IonPage>
      <Header titulo="Fiscalización - Máquina" />
      <IonContent id="fiscalizacion">
        <div className="fisContainer">
          <PanelFiscalizacion />
          <div className="fisCard">
            <h4>Buscar Máquinas</h4>
            <IonItem>
              <IonInput
                value={filtro}
                onIonChange={handleFiltroChange}
                clearInput={true}
                placeholder="Buscar máquina por nombre o código"
              ></IonInput>
              <IonIcon icon={search} />
            </IonItem>
          </div>

          {maquinasPaginadas.map((maquina) => (
              <div className="fisCard" key={maquina.codBien}>
                <div>
                  <h4>Cod.{maquina.codBien}</h4>
                  <p>{maquina.descripcion}</p>
                </div>
                <div className="d-flex justify-content-between">
                  {/* Otros elementos de la máquina */}
                </div>
                <hr />
                <div>
                  <h4>Condición:</h4>
                  <IonSelect
                    value={maquina.calificacion ? maquina.calificacion.toString() : undefined}
                    placeholder="Condición"
                    interface="action-sheet"
                    onIonChange={(e) => handleCalificacionChange(maquina.codBien, parseInt(e.detail.value))}
                    className={isSubmitted && !maquina.calificacion ? "campo-obligatorio" : ""}
                  >
                    {estados.map((estado) => (
                      <IonSelectOption key={estado.id} value={estado.id.toString()}>
                        {estado.calificacion}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </div>
              </div>
            ))}
          {maquinasFiltradas.length > 0 && (
            <div className="fisPagination">
              <button
                type="button"
                className="fisPagination_btn"
                disabled={paginaActual === 1}
                onClick={() => setPaginaActual((prev) => Math.max(1, prev - 1))}
              >
                Anterior
              </button>
              <span className="fisPagination_text">
                Página {paginaActual} de {totalPaginas}
              </span>
              <button
                type="button"
                className="fisPagination_btn"
                disabled={paginaActual === totalPaginas}
                onClick={() =>
                  setPaginaActual((prev) => Math.min(totalPaginas, prev + 1))
                }
              >
                Siguiente
              </button>
            </div>
          )}
        </div>
        <ComentarioFiscalizacion/>
      </IonContent>
      <IonButton className="btn_fiscSave" onClick={handleGuardar}>
        Guardar
      </IonButton>
    </IonPage>
  );
};

export default withRouter(FiscalizarMaquina);
